import React from 'react';
import Nbsp from '@shared/components/Nbsp';
import SkeletonWrapper from '@shared/components/skeleton/SkeletonWrapper';

/**
 * @typedef {object} LabeledAppraisalAssignedCountProps
 * @property {string} [label]
 * @property {string|number} [text]
 * @property {boolean} [loading]
 */

/**
 * @param {LabeledAppraisalAssignedCountProps} props
 */
const LabeledAppraisalAssignedCount = props => {
  const { label, text, loading } = props;
  return (
    <>
      <Nbsp />
      {label}:
      <Nbsp />
      <SkeletonWrapper show={loading} inheritParentSize={true}>
        <span>{text}</span>
      </SkeletonWrapper>
    </>
  );
};

export default LabeledAppraisalAssignedCount;
